export const PERMISSION_DELETE_PERMISSION_BEGIN = 'PERMISSION_DELETE_PERMISSION_BEGIN';
export const PERMISSION_DELETE_PERMISSION_SUCCESS = 'PERMISSION_DELETE_PERMISSION_SUCCESS';
export const PERMISSION_DELETE_PERMISSION_FAILURE = 'PERMISSION_DELETE_PERMISSION_FAILURE';
export const PERMISSION_DELETE_PERMISSION_DISMISS_ERROR = 'PERMISSION_DELETE_PERMISSION_DISMISS_ERROR';
export const PERMISSION_GET_FLAGS_BEGIN = 'PERMISSION_GET_FLAGS_BEGIN';
export const PERMISSION_GET_FLAGS_SUCCESS = 'PERMISSION_GET_FLAGS_SUCCESS';
export const PERMISSION_GET_FLAGS_FAILURE = 'PERMISSION_GET_FLAGS_FAILURE';
export const PERMISSION_GET_FLAGS_DISMISS_ERROR = 'PERMISSION_GET_FLAGS_DISMISS_ERROR';
export const PERMISSION_LOAD_PROJECT_DETAIL_BEGIN = 'PERMISSION_LOAD_PROJECT_DETAIL_BEGIN';
export const PERMISSION_LOAD_PROJECT_DETAIL_SUCCESS = 'PERMISSION_LOAD_PROJECT_DETAIL_SUCCESS';
export const PERMISSION_LOAD_PROJECT_DETAIL_FAILURE = 'PERMISSION_LOAD_PROJECT_DETAIL_FAILURE';
export const PERMISSION_LOAD_PROJECT_DETAIL_DISMISS_ERROR = 'PERMISSION_LOAD_PROJECT_DETAIL_DISMISS_ERROR';
